/**
 * @file
 *
 * Constants.
 */

export default interface Option {
  value: number | string
  label: string
}

export const MDVIP_PHONE = '1.877.866.1411'
export const MDVIP_PHONE_HREF = 'tel:+18778661411'
export const MDVIP_LOGIN_LINK = 'https://login.mdvip.com'
export const MDVIP_SLOGAN = 'Fast & Secure, No Sign-in Needed'
export const MDVIP_INVOICE_SLOGAN = 'Welcome! To securely view and pay your invoice, please verify your identity first.'
export const MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
]

export const STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
]

export const MDVIP_VERIFY_ACCOUNT_ERROR_MESSAGE = 'Additional information is needed to process payment.'

export const MDVIP_ACCOUNT_TIMEOUT_ERROR_MESSAGE =
  'You have been logged out due to inactivity. Please reauthenticate to continue.'

export const MDVIP_VERIFY_ACCOUNT_ERROR_PHONE = '1-877-866-1411'

export const CONTACT_MDVIP_MEMBER_SERVICES_MESSAGE =
  'Please contact MDVIP Member Services at <a href="tel:' +
  MDVIP_VERIFY_ACCOUNT_ERROR_PHONE +
  '">' +
  MDVIP_VERIFY_ACCOUNT_ERROR_PHONE +
  '</a>.'

export const MDVIP_VERIFY_ACCOUNT_DEFAULT_ERROR_HTML =
  MDVIP_VERIFY_ACCOUNT_ERROR_MESSAGE + CONTACT_MDVIP_MEMBER_SERVICES_MESSAGE

export const AUTOPAY_MESSAGE = 'Oops! We were not able to enroll you in Autopay.'

export const AUTOPAY_ENABLED_ERROR_MESSAGE = AUTOPAY_MESSAGE + ' ' + CONTACT_MDVIP_MEMBER_SERVICES_MESSAGE

export const AUTOPAY_SKIPPED_TRANSACTION_ID = 'autopay-skipped'

export const VALID_CLIENT_SIDE_ERRORS = [
  'Address',
  'Address2',
  'Amount',
  'BillingZipCode',
  'City',
  'ExpirationMonth',
  'ExpirationYear',
]

export interface UTMData {
  Source_URL__c: string | null
  Web_MD_Domain__c: string | null
  UTM_Campaign__c: string | null
  UTM_Medium__c: string | null
  UTM_Source__c: string | null
  UTM_Term__c: string | null
}

/**
 * Convert the string to the safe CSS class.
 *
 * @param {string} name
 *   Any string.
 */
export function makeSafeForCSS(name: string) {
  return name.replace(/[^a-z0-9]/g, function (s: string) {
    const c = s.charCodeAt(0)
    if (c == 32) return '-'
    if (c >= 65 && c <= 90) return '_' + s.toLowerCase()
    return '__' + ('000' + c.toString(16)).slice(-4)
  })
}

export const INVOICE_MESSAGE = 'Your invoice cannot be displayed at this time.'

export const MDVIP_INVOICE_DISABLED_MESSAGE = INVOICE_MESSAGE + ' ' + CONTACT_MDVIP_MEMBER_SERVICES_MESSAGE

export const DEFAULT_ERROR_MESSAGE = 'An Error occurred. Please try again later.'

export const DEFAULT_MAX_PAYMENT_AMOUNT = 6461
export const DEFAULT_MAX_PAYMENT_AMOUNT_MESSAGE = 'The payment amount must be less than $' + DEFAULT_MAX_PAYMENT_AMOUNT

export const INFORMATION_NOT_VALID_MESSAGE =
  'The information you entered is not valid. Please double check it and try again.'
